import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Navigate } from 'react-router-dom';

import GroupSelect, { Group } from '../../../components/group/GroupSelect';
import AmountInput from '../../../components/layout/AmountInput';
import Content from '../../../components/layout/Content';
import AddConsumptionModal from '../../../components/layout/modals/AddConsumptionModal';

import Button from '../../../components/ui/Button';
import Card from '../../../components/ui/Card';

import { useAppSelector } from '../../../store/hooks';
import { addConsumption } from '../../../store/utils';

import classes from './Add.module.css';

const Add = () => {
  const [group, setGroup] = useState<Group>({ value: '', label: '', score: 0 });
  const [amount, setAmount] = useState<number | string>('');
  const loggedIn = useAppSelector(state => state.auth.loggedIn);
  const [addButtonEnabled, setAddButtonEnabled] = useState(false);
  const [showAddConsumptionModal, setShowAddConsumptionModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setAddButtonEnabled(group.label !== '' && amount !== '' && (amount as number) > 0);
  }, [group, amount]);

  if (!loggedIn) {
    return <Navigate to="/login" />;
  }

  const groupChangeHandler = (group: Group) => {
    setGroup(group);
  };

  const amountChangeHandler = (amount: number) => {
    setAmount(amount);
  };

  const addConsumptionHandler = () => {
    setShowAddConsumptionModal(true);
  };

  const cancelAddConsumptionHandler = () => {
    setShowAddConsumptionModal(false);
  };

  const confirmAddConsumptionHandler = async () => {
    await addConsumption(group.value, group.label, amount as number, group.score);
    setShowAddConsumptionModal(false);
    setGroup({ value: '', label: '', score: 0 });
    setAmount('');
  };

  return (
    <Content>
      {showAddConsumptionModal && (
        <AddConsumptionModal
          groupName={group.label}
          amount={amount as number}
          onCancel={cancelAddConsumptionHandler}
          onConfirm={confirmAddConsumptionHandler}
        />
      )}
      <Card extraStyles={{ flex: 0.1 }} withMargin="bottom">
        <h1 style={{ fontSize: 'min(2em, 6vw)' }}>{t('addPage.title')}</h1>
      </Card>
      <Card extraStyles={{ justifyContent: 'flex-start', overflow: 'auto' }}>
        <div className={classes.selectContainer}>
          <p className={classes.label}>{t('addPage.name')}</p>
          <GroupSelect onChange={groupChangeHandler} value={group} />
          <p className={classes.label}>{t('addPage.amount')}</p>
          <AmountInput onChange={amountChangeHandler} value={amount} />
        </div>
        <Button
          disabled={!addButtonEnabled}
          extraStyles={{ marginTop: 'min(4em, 10vh)' }}
          onClick={addConsumptionHandler}
        >
          {t('addPage.add')}
        </Button>
      </Card>
      <Card extraStyles={{ flex: 0.1 }} withMargin="top">
        <Link to="..">
          <Button>{t('buttons.back')}</Button>
        </Link>
      </Card>
    </Content>
  );
};

export default Add;

export const loader = () => {};
